export const vietnamese = {
  translation: {
    // ================================= titles =================================
    titles: {
      popular_add_ons: 'Đề xuất thêm cho bạn',
      top: 'Trang chủ',
      hello: 'Xin chào',
      in_your_cart: 'Giỏ hàng của bạn',
      search_result: 'Kết quả tìm kiếm',
      call_staff: 'Chúng tôi đã nhận được yêu cầu của bạn',
      no_items_found: '0 mặt hàng được tìm thấy',
      search_empty: 'Không có kết quả phù hợp',
      sub_total: 'Tổng tiền',
      total: 'Tổng cộng',
      order_details: 'Thông tin gọi món',
      order_history: 'Lịch sử đơn hàng',
      popup_pay: 'Bạn muốn thanh toán?',
      payment_success: 'Chúng tôi đã nhận được yêu cầu thanh toán của bạn',
      order_empty: 'Bạn chưa gọi món',
      pending: 'Chờ xác nhận',
      served: 'Đã xác nhận',
      confirmed: 'Đã xác nhận',
      finish_cooking: 'Món ăn đã sẵn sàng',
      cancelled: 'Đã hủy',
      ready_to_order: 'Bạn đã sẵn sàng gọi món?',
      order_success: 'Chúng tôi đã nhận được yêu cầu của bạn',
      maxQuantityPerOrder: 'Số lượng tối đa/đơn hàng',
      topping_type_quantity: 'Tối thiểu {{min}} - Tối đa {{max}}',
      menu_excludes_vat: 'Giá này chưa bao gồm thuế VAT',
      rescanQR: 'Quét mã QR để gọi thêm món.',
      choose_language_to_start: 'Vui lòng chọn ngôn ngữ',
      extraFee: 'Phụ phí',
      discountAmount: 'Giảm giá',
      customizedService: 'Bạn có yêu cầu gì',
      selectOption: 'Vui lòng chọn một mục bên dưới',
      call_staff_reasons: 'Gọi nhân viên',
      choose_payment_method: 'Chọn phương thức thanh toán',
      payment_successfully: 'Thanh toán thành công',
      payment_failed: 'Thanh toán không thành công',
      how_was_your_experience: 'Hãy cho chúng tôi biết trải nghiệm của bạn',
      your_details: 'Nhập thông tin của bạn',
      how_many_people: 'Bạn có bao nhiêu người?',
      please_select_number_of_people: '*Vui lòng chọn số lượng người, bao gồm cả trẻ sơ sinh.',
      choose_number_of_people: 'Vui lòng chọn số lượng người tương ứng:',
      buffet: 'Buffet',
      order_placed: 'Đặt món thành công!',
      order_code: 'Mã đơn hàng',
      review_order: 'Hãy để lại đánh giá về chúng tôi tại đây',
      popular: 'Phổ biến',
      review_success: 'Xin chân thành cảm ơn!',
      hope_you_enjoyed: 'Hy vọng quý khách đã có một trải nghiệm tuyệt vời.',
      popup_food_error_order:
        'Món <span style="font-weight:{{fontWeight}}">{{nameFood}}</span> đã hết!',
      popup_topping_error_order:
        'The topping <span style="font-weight:{{fontWeight}}">{{nameTopping}}</span> out of stock!',
      input_a_name: 'Nhập họ tên',
      input_a_phone: 'Nhập số điện thoại',
      why_we_need_it: 'Vì sao cần làm điều này?',
      discount: 'Giảm giá',
      // tablet
      search: 'Tìm theo món',
      call_staff_tablet: 'Gọi nhân viên',
      bill: 'Hoá đơn',
      pay: 'Thanh toán',
      table_number: 'Bàn số:',
      ask_for_bill: 'Yêu cầu lấy hoá đơn',
      ask_for_bill_decription:
        'Quý khách muốn nhận hoá đơn vui lòng nhấn nút "Yêu cầu lấy hoá đơn"',
      not_yet: 'Để sau',
      quantity: 'Số lượng',
      item_table: 'Tên món ăn',
      status_table: 'Trạng thái',
      price_table: 'Số tiền',
      other: 'Khác',
    },
    // ================================= descriptions =================================
    descriptions: {
      reached_end: 'Bạn đang ở cuối trang',
      cart_empty: 'Giỏ hàng của bạn đang trống',
      hint_cart_empty: 'Nhấn vào đây để xem menu',
      search_empty: 'Vui lòng kiểm tra chính tả hoặc thử các từ khóa khác',
      call_staff: 'Vui lòng chờ một chút nhé! Nhân viên phục vụ của chúng tôi sẽ tới ngay.',
      popup_pay: "Click vào 'Yêu cầu hóa đơn' để nhân viên cung cấp hóa đơn",
      payment_success: 'Vui lòng chờ một chút nhé! Nhân viên phục vụ của chúng tôi sẽ tới ngay.',
      restaurant_on_capichi:
        'Nhà hàng áp dụng giao đồ ăn qua ứng dụng <span style="color:{{colorText}}">Capichi Delivery</span>',
      order_empty: 'Hãy đặt món mà bạn yêu thích ngay nhé',
      orderNotFound: 'Không tìm thấy đơn hàng',
      order_success:
        'Vui lòng đợi trong vài phút, món ăn của bạn sẽ được phục vụ trong thời gian sớm nhất.',
      rescanQR: 'Vui lòng quét mã QR để quay lại menu và chọn món bạn muốn gọi thêm nhé.',
      order_food_and_drink: 'Gọi món bất cứ lúc nào bạn muốn',
      seek_for_help: 'Đề nghị nhân viên hỗ trợ online nhanh chóng',
      ask_to_pay: 'Yêu cầu thanh toán dễ dàng',
      or_ask_directly: 'hoặc yêu cầu trực tiếp',
      haveVAT: 'Chưa bao gồm {{vatRate}}% VAT',
      haveServiceFee: 'Phí dịch vụ {{serviceRate}}%',
      popup_payment_success:
        'Thanh toán đã được xác nhận. Cảm ơn vì đã sử dụng dịch vụ của chúng tôi và hy vọng bạn đã có những trải nghiệm ăn uống tuyệt vời.',
      popup_payment_failed:
        'Đã xảy ra lỗi. Vui lòng thử lại sau hoặc lựa chọn phương thức thanh toán khác.',
      tap_to_save_screen: 'Vui lòng cho nhân viên tại nhà hàng xem màn hình này',
      checkouted_order: `Cảm ơn vì đã lựa chọn dùng bữa tại nhà hàng của chúng tôi ngày hôm nay.
      Vui lòng chia sẻ cảm nhận và ý kiến đánh giá để chúng tôi có thể nâng cao chất lượng dịch vụ và đem tới sự hài lòng hơn cho quý khách trong thời gian tới.`,
      review_success:
        'Chúng tôi đã nhận được đánh giá của Quý khách. Đây sẽ là những ý kiến đóng góp vô cùng giá trị đối với chúng tôi. Rất hân hạnh được tiếp đón và phục vụ Quý khách trong những bữa ăn tới.',
      input_a_name:
        'Bạn hiện đang đặt món từ một bàn có nhiều đơn hàng khác nhau. Để nhà hàng có thể phục vụ đúng món ăn tới bạn, vui lòng giúp chúng tôi nhập tên gọi đơn giản mà bạn mong muốn. Xin cảm ơn!',
      input_a_phone:
        'Số điện thoại này được dùng để nhận các tin nhắn thông báo về tình trạng đơn hàng khi bạn đặt hàng thành công.',
      min_left: 'Bạn có thể gọi buffet từ menu phía bên dưới trong vòng {{min_left}} phút',
    },
    // ================================= actions =================================
    actions: {
      call_staff: 'Gọi nhân viên',
      pay: 'Thanh toán',
      back_to_top: 'Quay về đầu trang',
      order: 'Đặt món',
      go_back: 'Quay lại',
      see_menu: 'Xem menu',
      order_now: 'Đặt món ngay',
      clear_all: 'Xóa hết',
      search_again: 'Tìm kiếm lại',
      retry: 'Thử lại',
      back_to_menu: 'Quay lại menu',
      ask_for_bill: 'Yêu cầu hóa đơn',
      not_yet: 'Chưa sẵn sàng',
      discover: 'Khám phá',
      delete_dish: 'Xóa món',
      noteFood: 'Ghi chú thêm cho món',
      addToCart: 'Thêm vào giỏ hàng',
      addNote: 'Thêm ghi chú',
      confirmOrder: 'Đặt món',
      start_ordering: 'Bắt đầu gọi món',
      pay_online: 'Thanh toán ngay',
      send: 'Gửi',
      try_again: 'Thử lại',
      call_staff_for_help: 'Gọi nhân viên hỗ trợ',
      skip: 'Bỏ qua',
      next: 'Tiếp theo',
      done: 'Hoàn thành',
      confirm: 'Xác nhận',
      order_from_here: 'Đặt tại đây',
      tap_to_save_screen: 'Ấn để lưu lại màn hình',
      see_a_menu: 'Xem menu',
      update: 'Cập nhật',
      cancel: 'Huỷ',
      add: 'Áp dụng',
      ok: 'OK',
      see_the_time: 'Xem thời gian',
    },
    // ================================= errors =================================
    errors: {
      server_error: 'Không thể kết nối với máy chủ',
      errorOutOfStock: 'Xin lỗi, các món ăn này đã hết hàng, bạn vui lòng đặt món ăn khác.',
      errorQuantityPerOrder:
        'Số lượng món ăn bạn chọn đã vượt quá số lượng tối đa. Vui lòng chọn lại.',
      errorQuantityExceeded:
        'Xin lỗi, món ăn này không đủ số lượng để đáp ứng đơn hàng của bạn. Hãy chọn lại số lượng món ăn.',
      somethingWrong: 'Có lỗi xảy ra, vui lòng thử lại!',
      errorFoodHasChanged:
        'Xin lỗi, nhà hàng vừa cập nhật lại thông tin món ăn vui lòng khởi tạo lại đơn hàng',
      warningMin: 'Vui lòng đặt tối thiểu {{min}} topping',
      warningMax: 'Vui lòng chỉ đặt tối đa {{max}} topping',
      notFoundFoodItem: 'Nhà hàng tạm thời dừng phục vụ món ăn này. Vui lòng thử lại sau.',
      errorNotOpenTable:
        'Bàn của quý khách đang ngồi chưa được mở. Vui lòng gọi nhân viên để được phục vụ.',
      max_comment_review: 'Tối đa {{max}} kí tự',
      payment_method_changed: 'Các phương thức thanh toán đã được cập nhật.',
      payment_method_changed_desc:
        'Vui lòng làm mới trang và chọn phương thức thanh toán khả dụng.',
      max_characters: 'Vui lòng điền tối đa {{max}} ký tự',
      required_floor: 'Vui lòng nhập số tầng',
      required_room: 'Vui lòng nhập số phòng',
      required_full_name: 'Vui lòng nhập họ và tên',
      errorOutOfStockNEC: 'Hết món',
      rating_already_existed: 'Bạn đã đánh giá đơn hàng này.',
      voucher_not_suitable: 'Mã ưu đãi không hợp lệ. Vui lòng thử lại',
      error: 'Lỗi',
      voucher_not_found: 'Mã ưu đãi này không tồn tại trong hệ thống. Vui lòng nhập mã khác.',
      voucher_outside_time_period:
        'Mã ưu đãi này chưa đến ngày sử dụng hoặc đã hết hạn. Vui lòng nhập mã khác.',
      voucher_just_apply_for_restaurants:
        'Mã ưu đãi này chỉ có thể áp dụng tại các nhà hàng: {{restaurants}}',
      voucher_min_order_value:
        'Mã ưu đãi này chỉ có thể áp dụng cho đơn hàng từ {{min_order_value}}',
      voucher_has_been_used: 'Mã ưu đãi này đã được sử dụng',
      voucher_out_of_quantity: 'Mã ưu đãi này đã hết số lượt sử dụng. Vui lòng nhập mã khác.',
      min_max_phone_number: 'Vui lòng nhập số điện thoại từ {{min}}-{{max}} ký tự.',
    },
    // ================================= languages =================================
    languages: {},
    // ================================= label =================================
    label: {
      required: 'Bắt buộc',
      optional: 'Tùy chọn',
      my_cart: 'Giỏ hàng',
      items_found: 'kết quả đã được tìm thấy ',
      sold_out: 'Hết món',
      items: 'món',
      powered_by: 'Powered by',
      vat: 'VAT',
      service_fee: 'Phí dịch vụ',
      your_order: 'Đơn hàng của bạn',
      or: 'hoặc',
      payment_methods: {
        international_card: 'Thẻ tín dụng/ghi nợ',
        atm: 'Thẻ nội địa',
        qr_code: 'Chuyển khoản với mã QR',
        e_wallet: 'Ví điện tử',
      },
      review_or_comment: 'Để lại đánh giá để chúng tôi có thể làm tốt hơn',
      only_letters: 'chỉ nhập chữ cái',
      buffet: 'Buffet',
      min_left: 'Còn <strong style="color:{{color}}">{{min_left}}</strong> phút',
      all_you_can_drink: 'Tất cả đồ uống có thể gọi',
    },
    // ================================= placeholder =================================
    placeholder: {
      input_search: 'Tìm kiếm món ăn, đồ uống',
      choose_your_floor: 'Chọn số tầng',
      choose_your_room: 'Chọn số phòng',
      your_full_name: 'Nhập họ và tên',
      no_results: 'Không có kết quả tìm kiếm',
      your_name: 'Tên của bạn',
      enter_voucher_code: 'Nhập mã ưu đãi',
      your_phone: 'Số điện thoại của bạn',
    },
    popup_start_buffet: {
      course_menu_has_started: 'Các món buffet đã bắt đầu',
      time_limit: 'Giới hạn thời gian',
      time_value: '{{value}} phút',
      see_menu: 'Xem menu',
    },
    popup_add_friend_line: {
      line: 'LINE',
      description:
        'Vui lòng kết bạn với chúng tôi trên ứng dụng LINE để sử dụng dịch vụ đặt hàng qua di động.',
      add_friend_btn: 'Thêm bạn trên LINE',
      already_added: 'Đã thêm bạn',
    },
  },
}
